import { r4Client, r4Error } from '@/services'
import useLogger from '@/composables/useLogger'
const logger = useLogger('ProfileStore')

const profileParams = payload => {
  return payload
}

const ProfileStore = {
  namespaced: true,
  state: {
    profile: {}
  },
  mutations: {
    saveProfile: (state, payload) => {
      // handle cases were coming from API (.data) and from setting directly from list
      if (!payload) {
        state.profile = {}
      } else if (payload.data) {
        state.profile = payload.data
      } else {
        state.profile = payload
      }
    },
    resetProfile: state => {
      state.profile = {}
    }
  },
  actions: {
    saveProfile ({ dispatch, state, commit }, payload) {
      const profileData = profileParams(payload)
      return new Promise((resolve, reject) => {
        r4Client()
          .put('/api/v1/profile', profileData)
          .then(response => {
            logger.trace('UpdateProfile: Success')
            commit('saveProfile', response.data)
          }).then(() => {
            resolve(state.profile)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    getProfile ({ state, commit }) {
      return new Promise((resolve, reject) => {
        return r4Client()
          .get(`/api/v1/profile`)
          .then(response => {
            commit('saveProfile', response.data)
            resolve(state.profile)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    backendSyncProfile ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        r4Client()
          .post('/api/v1/profile/sync_with_cognito', {})
          .then(response => {
            logger.trace('Successfully sync with cognito')
            dispatch('getProfile')
            resolve(response)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    }
  },
  getters: {}
}

export default ProfileStore
